// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-c8k","label":"styles_label__1UTLQ"};